var React = require('react');

function Section3BottomRightInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("polygon",{"fill":"#F4EBFE","points":"47.88 130.953 0 76.751 45.58 60","key":0}),React.createElement("polygon",{"fill":"#C5F6D5","points":"222.086 5.209 313.968 42.55 274.967 130.518 183.085 93.178","key":1}),React.createElement("circle",{"cx":"175","cy":"11","r":"11","fill":"#FED7D7","key":2})]));
}

Section3BottomRightInline.defaultProps = {"width":"314","height":"131","viewBox":"0 0 314 131"};

module.exports = Section3BottomRightInline;

Section3BottomRightInline.default = Section3BottomRightInline;
